import type { FaviconPaint } from './types';

/** The edge of the composed icon, in px. Paints draw relative to it. */
export const FAVICON_SIZE = 64;

/**
 * Browser-only default compose: draws `base` (the app icon) at 64 px, runs each
 * paint over it in the order given, and returns a PNG data URL. Returns null on
 * any canvas failure, which includes jsdom: it has no canvas and no
 * `HTMLImageElement.decode`, so the icon links stay as they are there.
 */
export async function composeFavicon(
  paints: readonly FaviconPaint[],
  base = '/icon-192.png',
): Promise<string | null> {
  try {
    const img = new Image();
    img.src = base;
    await img.decode();
    const canvas = document.createElement('canvas');
    canvas.width = FAVICON_SIZE;
    canvas.height = FAVICON_SIZE;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, FAVICON_SIZE, FAVICON_SIZE);
    for (const paint of paints) paint(ctx, FAVICON_SIZE);
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}
